import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import PopupManager from '../utils/PopupManager';
import NewsletterLogic from '../logics/NewsletterLogic';
import { IS_PRIVACY_PAGE } from '../utils/Environment';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import TimerController, { bindTimerStateEvents } from '../utils/TimerController';

export default class NewsletterPopupComponent extends Component {
  get SELECTORS() {
    return {
      doItLater: '[data-do-it-later]',
      input: '[data-newsletter-input]',
      formBox: '[data-newsletter-form-box]',
      closeBtn: '[data-close-popup]',
      loginPopup: ".js-login-popup"
    };
  }

  get CLASSES() {
    return {
      success: 'success',
      componentExtended: 'extended',
    };
  }

  get STATICS() {
    return {
      popupLoginClose: 'login_popup_close'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.doItLater = this.$component.querySelector(this.SELECTORS.doItLater);
    this.newsletterPopupTimer = document.body.dataset.newsletterPopupTimer;
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();

    // TimerController: initial states
    this.layerStates = {
      menuOpen: false,
      loginOpen: false,
      searchOpen: false,
      chatOpen: false,
      lastTimerPaused: null,
    };
    this.timerController = null;
  }

  // istantiate properties
  initProperties() {
    this.modalkey = document.body.dataset.nlKey || 'default_modal';
    this.link = document.body.dataset.nlLink || '/modals/newsletter';
    this.hideCookieKey =  `nl_${this.modalkey}_hide`;
  }

  listenEmailInput(component) {
    let mailInput = component.$component.querySelector(this.SELECTORS.input);
    if (mailInput != null) {
      mailInput.addEventListener('focus', () => {
        let formBox = component.$component.querySelector(
          this.SELECTORS.formBox
        );
        if (formBox != null) {
          formBox.classList.add(this.CLASSES.componentExtended);
        }
      });
    }
  }

  bindEvents() {
    const ctx = this;

    if (this.doItLater) {
      this.doItLater.addEventListener('click', () =>
        this.$emit(this.$customEvents.NL_POPUP_EVENTS.hide)
      );
    }

    const newsletterPopupTimer = parseInt(this.newsletterPopupTimer) ?? 0;

    // controllo presenza cookie, se in pagina privacy e se esiste la login popup
    const visibleLoginPopup = document.querySelector(this.SELECTORS.loginPopup) !== null && !Cookies.get(this.STATICS.popupLoginClose);

    if (
      !Cookies.get(this.hideCookieKey) &&
      !IS_PRIVACY_PAGE &&
      !visibleLoginPopup
    ) {

      // TimerController: Initializes the timer controller instance.
      this.timerController = new TimerController({
        delay: newsletterPopupTimer,
        shouldPauseFn: () => {
          const isAnyLayerOpen = Object.entries(this.layerStates)
            .filter(([key]) => key !== 'lastTimerPaused')
            .some(([_, state]) => state);
          const isMobileMenu = isAnyLayerOpen  && isMobile(MobileBreakpoint.Max1023);
          const currentLayerState = isAnyLayerOpen || isMobileMenu;

          if (currentLayerState !== this.layerStates.lastTimerPaused) {
            /* Debug for Layer States
              console.log("TimerController: in NewsletterPopupController pause state changed", {
                isAnyLayerOpen,
                isMobileMenu,
                shouldPause: currentLayerState
              });
            */
            this.layerStates.lastTimerPaused = currentLayerState;
          }

          return currentLayerState;
        },
        /* TimerController: debug callbacks for timer events */
       /*
       onStart: (progress, remaining) => {
         console.info('TimerController: in NewsletterPopupController timer started', { progress, remaining });
        },
        onPause: (progress, remaining) => {
          console.info('TimerController: in NewsletterPopupController timer paused', { progress, remaining });
        },
        onResume: (progress, remaining) => {
          console.info('TimerController: in NewsletterPopupController timer resumed', { progress, remaining });
        },*/
        onComplete: () => {
          this.$emit(this.$customEvents.NL_POPUP_EVENTS.show, { component: this });
        }
      });

      this.timerController.start();
    }

    this.$on(this.$customEvents.NL_POPUP_EVENTS.show, ({ payload }) => {
      ctx.listenEmailInput(payload.component);
    });

    // after subscription event
    this.$on(this.$customEvents.NL_POPUP_EVENTS.subscribed, () => {
      // set cookie
      this.setHideCookie();
    });

    // after open event
    this.$on(this.$customEvents.NL_POPUP_EVENTS.shown, () => {
      let closeBtn = this.closeBtn;
      if (closeBtn != null) {
        closeBtn.addEventListener('click', () => {
          this.setHideCookie();
        });
      }
    });

    // TimerController: Listen to layer state changes
    bindTimerStateEvents.call(this);
  }

  setHideCookie() {
    Cookies.set(this.hideCookieKey, 'true', {
      expires: 365,
      path: '/',
    });
    // TimerController: Destroy the timer after subscription
    this.destroyTimer();
  }

  // TimerController: toggles timer state, pauses if needed or resumes if already paused.
  handleTimerStateChange() {
    if (this.timerController) {
      if (this.timerController.shouldPauseFn()) {
        this.timerController.pause();
      } else if (this.timerController.isPaused) {
        this.timerController.resume();
      }
    }
  }

  // TimerController: Destroy Timer
  destroyTimer() {
    try {
      if (this.timerController) {
        this.timerController.destroy();
        this.timerController = null;
      }
    } catch (error) {
      console.error('TimerController: Error in NewsletterPopupComponent destroying timer controller:', error);
    }

    try {
      if (super.destroy && typeof super.destroy === 'function') {
        super.destroy();
      }
    } catch (error) {
      console.error('TimerController: Error in NewsletterPopupComponent calling parent destroy:', error);
    }
  }

  render() {
    // properties
    this.initProperties();

    // popup manager
    this.popupManager = new PopupManager({
      eventGroup: 'NL_POPUP_EVENTS',
      component: this.$component,
    });

    // events
    this.bindEvents();
  }
}
